import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { postFeedback } from 'proposals/api/procurementApiClient'

export const useSendFeedbackMutation = (token: string): UseMutationResult<void, unknown, PostFeedbackType, unknown> => {
  return useMutation({
    mutationFn: (payload: PostFeedbackType) => postFeedback(token, payload)
  })
}
